import React from "react";
import {
  FormLabel,
  FormControl,
  FormGroup,
  FormControlLabel,
  Checkbox,
} from "@material-ui/core";
import styles from "./FeedbackCheckbox.module.scss";
import makeStyles from "@material-ui/styles/makeStyles";
import clsx from "clsx";

const useStyles = makeStyles(theme => ({
  root: {
    "& .MuiFormControl-root": {
      minWidth: "480px !important",
    },
    "& .MuiFormControlLabel-root ": {
      backgroundColor: "#f5f5f5",
      borderRadius: "1.5rem",
    },
    "& .MuiSvgIcon-root": {
      fill: "#0A859A",
    },
    "& MuiTypography-root": {
      color: "#757575",
    },
  },
}));

const FeedbackCheckBox = ({ inputID, checkBoxList, updateSelectionFormData }) => {
  const classes = useStyles();
  return (
    <div className={clsx(classes.root, styles.container)}>
      <FormControl component="fieldset" variant="standard">
        <FormLabel
          className={styles.paddingBottom}
          focused={false}
          component="legend"
        >
          You can select more than one
        </FormLabel>
        <FormGroup>
          {checkBoxList && checkBoxList.length > 0 &&
            checkBoxList.map(item => (
              <FormControlLabel
                key={item.id}
                control={
                  <Checkbox
                    id={`${item.id}`}
                    checked={item.checked}
                    onChange={(event) => {
                      const currentItemID = event.target.id;
                      updateSelectionFormData({ inputID, currentItemID, [inputID]: checkBoxList });

                    }}
                    name={item.description}
                  />
                }
                label={item.description}
              />
            ))}
        </FormGroup>
      </FormControl>
    </div>
  );
};

export default FeedbackCheckBox;
